import { Component, OnInit, Inject, ElementRef, ViewChild, AfterContentInit, DoCheck, AfterViewInit, AfterViewChecked, AfterContentChecked } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { User, Role, Module } from '../../../pages/users/user.model';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { SettingsService } from '../../../pages/settings/settings.service';
import { PaymentService } from "../../services/payment.service";
import { HostListener } from "@angular/core";

import * as moment from 'moment';
declare var $: any;
import * as jspdf from 'jspdf';  
import html2canvas from 'html2canvas'; 

@Component({
  selector: 'app-oxxo-pay-dialog',
  templateUrl: './oxxo-pay-dialog.component.html',
  styleUrls: ['./oxxo-pay-dialog.component.scss'],
  providers: [ SettingsService, PaymentService ]
})
export class OxxoPayDialogComponent implements OnInit{

  public user: User;
  public titleButton: string;
  public cxc: any;
  public clicked: boolean = false;
  public isBlocked: boolean = false;
  public hidden_order: boolean = true;
  public invoice = new FormControl(null, [Validators.required]);
  public rfc = new FormControl(null);
  public business_name = new FormControl(null);
  scrHeight:any;
  scrWidth:any;
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;
  }

  constructor(
            public settingsService: SettingsService,
            public paymentService: PaymentService,
            public dialogRef: MatDialogRef<OxxoPayDialogComponent>,
            @Inject(MAT_DIALOG_DATA) public data: any,
            public fb: FormBuilder,
            private toastr: ToastrService
        ) {
          
          console.log(data);
          this.titleButton = data.titleButton;
          this.user = AuthService.getUser();
          this.cxc = this.data.cxc;
  }

  ngOnInit(){
  }

  searchOxxoReference(){
    if(this.invoice.value == null && this.user.business_id == 1){
      this.toastr.error("Indique SI requiere o NO factura");
      return;
    }
    if((this.invoice.value == '1' && (this.isNullOrWhitespace(this.rfc.value) || this.isNullOrWhitespace(this.business_name.value))) && this.user.business_id == 1){
      this.toastr.error("Capture RFC y Razon social para continuar");
      return;
    }

    if(this.cxc){
      this.clicked = true;
      this.isBlocked = true;
      const data = {
        matricula: this.user.registration,
        amount: this.cxc.monto,
        transaction: (this.user.business_id == 3 ? '' : this.cxc.inst_clave) + moment().format('YYYYMMDDhhmmss') + this.cxc.cuenta_cobrar_id,
        who: 'studentportal',
        curp: this.user.curp,
        student_name: this.user.name + ' ' + this.user.lastname,
        name: this.user.name + ' ' + this.user.lastname,
        phone: '8181818181',
        concept: this.data.concept,
        description: this.cxc.descripcion + ' - ' + this.cxc.ciclo_id,
        email: this.user.email,
        id_runway: 3,
        conektaTokenId: '',
        want_invoice: this.invoice.value,
        rfc: this.invoice.value == '1' ? this.rfc.value: null,
        business_name: this.invoice.value == '1' ? this.business_name.value : null,
        business_id: this.user.business_id,
        type_payment: 'oxxo_cash',
        inst_id: this.cxc.inst_id,
      }

      this.paymentService.searchOxxoReference(data).subscribe(res => {
        console.log(res);
        if (res.exists) {
          this.isBlocked = false;
          this.hidden_order = false;
            $("#reference_oxxo_pay").text(res.row.reference.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1-').trim());
            $("#amount_oxxo_pay").text('$' + parseFloat(res.row.amount).toFixed(2) + ' ');
            $("#expires_at").text('Expira el ' + new Date(res.row.expires_at * 1000).toLocaleDateString('en-IN'));
            $("#img_reference").attr("src","data:image/png;base64," + res.row.barcode_url);
        } else {
          this.paymentService.payckta(data).subscribe(res => {
            console.log(res);
            this.isBlocked = false;
            if (res.success) {
              this.hidden_order= false;
              $("#reference_oxxo_pay").text(res.pay.reference.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1-').trim());
              $("#amount_oxxo_pay").text('$' + parseFloat(res.pay.amount).toFixed(2) + ' ');
              $("#expires_at").text('Expira el ' + new Date(res.order.charges.data[0].payment_method.expires_at * 1000).toLocaleDateString('en-IN'));
              $("#img_reference").attr("src","data:image/png;base64," + res.pay.barcode_url);
          } else {
              alert(res.message);
          }
          });
        }
      });
    }else{
      this.toastr.error("Ocurrio un error al generar la cuenta por cobrar. Por favor intente nuevamente");
    }
  }

  isNullOrWhitespace( input ) {
    if (typeof input === 'undefined' || input == null) 
      return true;
    return input.replace(/\s/g, '').length < 1;
  }

  captureScreen(){  
    this.getScreenSize();
    var data = document.getElementById('reference_ckta');  
    html2canvas(data,{
      useCORS: true,
      allowTaint: true
    }).then(canvas => {  
      // Few necessary setting options  
      var imgWidth = 208;   
      if(this.scrWidth < 700){
        imgWidth = 100;
      } 
      var pageHeight = 295;    
      var imgHeight = canvas.height * imgWidth / canvas.width;  
      var heightLeft = imgHeight;  
  
      const contentDataURL = canvas.toDataURL('image/png')  
      let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF  
      var position = 0;  
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight)  
      pdf.save('referencia_oxxopay.pdf'); // Generated PDF   
    });  
  }  
}
